const sanityCheckNumber = (number) => {
    return !isNaN(number) && number !== null && !isNaN(Number(number));
}

export default sanityCheckNumber;